import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.106 10.252A3.25 3.25 0 0 1 5.404 9.3h5.2a3.25 3.25 0 0 1 3.25 3.25v1.3a.65.65 0 0 1-1.3 0v-1.3a1.95 1.95 0 0 0-1.95-1.95h-5.2a1.95 1.95 0 0 0-1.95 1.95v1.3a.65.65 0 1 1-1.3 0v-1.3c0-.862.342-1.689.952-2.298M8.004 2.8a1.95 1.95 0 1 0 0 3.9 1.95 1.95 0 0 0 0-3.9m-3.25 1.95a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })